import React from "react";
import { InputTextArea, ErrorMessage } from "@/lib/styles";

export default function TextArea(props: any) {
  const { _key, name = "", required = false, placeholder = "" } = props;
  return (
    <InputTextArea
      key={_key}
      onFocus={(e) => e.target.parentElement?.classList.remove("error")}
    >
      <label htmlFor={name}>{placeholder}</label>
      <textarea
        id={name}
        placeholder={`${placeholder}${required ? "*" : ""}`}
        rows={1}
        name={name}
        required={required}
      ></textarea>
      <ErrorMessage> Is Required! </ErrorMessage>
    </InputTextArea>
  );
}
